import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../redux/spinnerSlice";
import {
  getDoctorAppointments, updateAppointmentStatus,
  getHistoryOfPatient,
} from "../../api/api";
import moment from "moment";
import { Table, Row,Button } from "antd";
import toast from "react-hot-toast";

const DoctorAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [patientHistory, setPatientHistory] = useState([]);
  const dispatch = useDispatch();

  //Fetch Doctor Appointments
  const fetchDoctorAppointments = async () => {
    try {
      dispatch(showLoading());
      const res = await getDoctorAppointments();
      setAppointments(res.data);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDoctorAppointments();
  }, []);
  const handleDetails = async (record, status) => {
    try {
      const pname = record.pname;
      const data = { pname };
      dispatch(showLoading());
      const response = await getHistoryOfPatient(data);
      if (response.success) {
        toast.success(response.message);
        setPatientHistory(response.data);
        console.log(JSON.stringify(response.data));
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };
  //Handle Status
  const handleStatus = async (record, status) => {
    try {
      const appointmentsId = record._id;
      const data = { appointmentsId, status };
      dispatch(showLoading());
      const response = await updateAppointmentStatus(data);
      if (response.success) {
        toast.success(response.message);
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };

  // Antd table design
  const columns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "User Name",
      dataIndex: "name",
      render: (text, record) => <span>{record.userInfo.name}</span>,
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => <span>{record.userInfo.email}</span>,
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      render: (text, record) => (
        <span>
          {moment(record.date).format("DD MMM YYYY")} &nbsp;
          {moment(record.time).format("hh:mm A")}
        </span>
      ),
    },
    {
      title: "Appointments Type",
      dataIndex: "appoinmentType",
      key: "appoinmentType",
      render: (value) => (
        <span style={{ color: value ? "green" : "blue" }}>{value ? "Confirmed" : "Waiting"}</span>
      ),
    },
    
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <Button
          type={text === "APPROVE" ? "success" : text === "PENDING" ? "primary" : "default"}
          style={{
            textTransform: "uppercase",
            color: text === "pending" ? "blue" : text === "rejected" ? "red" : "green" 
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex">
          <button
            className="btn btn-success mx-2"
            onClick={() => handleDetails(record, "approved")}
          >
            Show History
          </button>
          {record.status === "pending" && (
            <div className="d-flex">
              <button
                className="btn btn-warning mx-2"
                onClick={() => handleStatus(record, "approved")}
              >
                Approved
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleStatus(record, "rejected")}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];
  const patientHistoryColumns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "Doctor Name",
      dataIndex: ["doctorInfo", "firstName"],
      key: "doctorName",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Last Visit",
      dataIndex: "lastVisit",
      key: "lastVisit",
      render: (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (time) => moment(time, "ddd MMM DD YYYY HH:mm:ss").format("hh:mm A"),
    },
  ];
  return (
    <Layout>
      <div className="table-responsive">
        <h1 className="m-4 text-center">Appointments List</h1>
        <Table
          columns={columns}
          dataSource={appointments}
          rowKey={(record) => record._id}
          scroll={{ x: "max-content" }}
        />
      </div>

      <div className="table-responsive">
        {patientHistory.length > 0 && (
          <><h2>Patient History</h2><Row>
            <br></br>
            <br></br>
            <Table dataSource={patientHistory} columns={patientHistoryColumns} /> {/* Render appointment data in a table */}
          </Row></>)}
      </div>
    </Layout>
  );
};

export default DoctorAppointments;
